import { NgModule } from "@angular/core";
import { DateTimeFormatPipe } from "./dateTimeFormat.pipe";
import { KeepHtmlPipe } from "./keepHTML.pipe";
import { WrapListHtmlPipe } from "./wrapListHTML.pipe";
import { KeepHtmlExtendPipe } from "./keepHTMLExtend.pipe";
import { FilterGiftPipe } from "./filterGift.pipe";
@NgModule({
  declarations: [DateTimeFormatPipe, KeepHtmlPipe, WrapListHtmlPipe, KeepHtmlExtendPipe, FilterGiftPipe],
  imports: [],
  exports: [DateTimeFormatPipe, KeepHtmlPipe, WrapListHtmlPipe, KeepHtmlExtendPipe, FilterGiftPipe],
})
export class PipesModule { }
